import { RegisterOptions, UseFormReturn } from 'react-hook-form'
import { autocomleteInputOffProps } from './props-autocomplete'
import { GenericTextInput } from './_generic-input'

type Props = {
  form: UseFormReturn<any>
  name: string
  label?: string
  placeholder?: string
  disabled?: boolean
  required?: boolean
  multiline?: boolean
  options?: RegisterOptions
  inputProps?: any,
  readOnly?: boolean
}

export const TextInput: React.FC<Props> = ({
  form,
  name,
  placeholder,
  label = 'Имя',
  disabled = false,
  required = true,
  multiline = false,
                                             readOnly = false,
  options,
  inputProps,
}) => {
  const { register, formState } = form

  return (
    <GenericTextInput
      register={register(name, { required,  ...options })}
      InputProps={{ ...(autocomleteInputOffProps as any), readOnly:readOnly, ...inputProps }}
      placeholder={placeholder}
      disabled={disabled}
      label={label}
      multiline={multiline}
      helperText={formState.errors[name]?.message}
    />
  )
}
